<!--
 * @Author: GeekMzy
 * @Date: 2023-02-09 16:23:15
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\components\map\LayersManage.vue
-->
<!-- 图层管理 -->
<template>
  <div class="layers-manage">
    <div v-if="showTimeUnit" class="filter_bar" style="display: flex; flex-direction: column">
      <div class="timeUnit">
        <div :class="timeUnit == 'd' ? 'timeUnitItem active' : 'timeUnitItem'" @click="changeTimeUnit('d')">
          当天
        </div>
        <div :class="timeUnit == 'w' ? 'timeUnitItem active' : 'timeUnitItem'" @click="changeTimeUnit('w')">
          本周
        </div>
        <div :class="timeUnit == 'm' ? 'timeUnitItem active' : 'timeUnitItem'" @click="changeTimeUnit('m')">
          本月
        </div>
      </div>
      <n-select v-model:value="problemType" :options="problemTypeList" size="small"
        style="width: 94px; height: 32px; margin-top: 10px" :on-update:value="onProblemTypeChange" />
    </div>

    <div v-if="$router.currentRoute.value.name == 'pollution'" class="pollution">
      <el-radio v-model="subType" :label="1" border @change="setSub">基础图层</el-radio>
      <el-radio v-model="subType" :label="2" border @change="setSub">临江河信息</el-radio>
    </div>

    <template
      v-if="$router.currentRoute.value.name != 'pollution' || $router.currentRoute.value.name == 'pollution' && subType == '1'">
      <div style="display: flex">
        <el-input placeholder="请输入需要查询的内容" v-model="keyword" class="input-with-select">
        </el-input>
        <el-button type="primary" @click="search">搜索</el-button>
      </div>
      <el-tree show-checkbox ref="layers-manage-tree" :data="data" node-key="label"
        :default-checked-keys="defaultCheckedKeys" :props="defaultProps" @check="handleNodeClick"></el-tree>
    </template>

    <template v-if="subType == '2'">
      <div class="ljh">
        <el-radio v-model="mType" :label="1" @change="setM">子流域空间分布</el-radio>
        <el-radio v-model="mType" :label="2" @change="setM">数字高程模型（DEM）</el-radio>
        <el-radio v-model="mType" :label="3" @change="setM">种植结构分布</el-radio>
        <el-radio v-model="mType" :label="4" @change="setM">土地利用类型分布</el-radio>
        <el-radio v-model="mType" :label="5" @change="setM">土壤类型分布</el-radio>
      </div>
    </template>
  </div>
</template>

<script>
import { THREE } from 'threebox-plugin'
import mapService, { BreatheLayer } from '@/utils/mapServices'
import {
  mapfilterUsingGET,
  autoSiteLastWaterLevelUsingGET,
  getWrjPathListUsingGET,
} from '@/api/api'
import { Api as SjApi } from '@/api/screenSj.ts'
import { Api as PublicApi } from '@/api/publicApi.ts'
import Bus from '@/config/Bus'
import gcoord from 'gcoord'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'
const mainStore = useMainStore(pinia)

export default {
  data() {
    return {
      showTimeUnit: false,
      timeUnit: 'd',
      defaultCheckedKeys: ['干流', '支流'],
      ly: '',
      zjName: '',
      keyword: '',
      subType: 1,
      mType: 1,
      data: [
        {
          label: '图层',
          children: [
            {
              label: '河库巡查',
              children: [
                {
                  label: '在线巡河',
                  icon: '在线巡河',
                  positions: 'xh_online',
                  type: 'custom',
                },
              ],
            },
            {
              label: '水环境质量',
              children: [
                {
                  label: '手工监测断面',
                  icon: '',
                  positions: 'sgjcdm',
                  type: 'custom',
                },
                {
                  label: '水质自动监测站',
                  icon: '',
                  positions: 'szzdjcz',
                  type: 'custom',
                },
              ],
            },
            {
              label: '水域污染源',
              children: [
                {
                  label: '污水处理厂（站）',
                  icon: '污水厂',
                  positions: 'wsclc',
                  type: 'custom',
                },
                {
                  label: '工业企业',
                  icon: '工业企业',
                  positions: 'zdgyqy',
                  type: 'custom',
                },
                {
                  label: '规模化畜牧养殖',
                  icon: '畜禽养殖',
                  positions: 'gmhxmyz',
                  type: 'custom',
                },
                {
                  label: '水产养殖',
                  icon: '水产养殖',
                  positions: 'scyz',
                  type: 'custom',
                },
                {
                  label: '污水排放口',
                  icon: '重点排水户',
                  positions: 'pwk',
                  type: 'custom',
                },
              ],
            },
            {
              label: '河库概况',
              children: [
                {
                  label: '干流',
                  layers: [
                    'sx-二级河流',
                    'sx-二级河流-12+',
                    'zj-河流注记',
                    'sx-河流流向',
                    'sx-河流中心线加粗',
                    'sx-二级河流-加粗',
                    'sx-二级河流-加粗2',
                    'xzgl-河流水质',
                  ],
                  type: 'map',
                },
                {
                  label: '支流',
                  layers: ['sx-支流线'],
                  type: 'map',
                },
                {
                  label: '水库',
                  icon: '水库',
                  positions: 'sk',
                  layers: ['sx-水库', 'zj-水库注记'],
                  type: 'map',
                },
                {
                  label: '饮用水源地',
                  icon: '饮用水源地',
                  positions: 'yysyd',
                },
              ],
            },
            {
              label: '监控视频',
              children: [
                {
                  label: '河道视频',
                  type: 'custom',
                  icon: '河道视频',
                  positions: 'spjcd',
                },
              ],
            },
            {
              label: '无人机航拍',
            },
            {
              label: '问题处置',
              children: [
                {
                  label: '问题上报',
                  type: 'custom',
                  icon: 'riverDetails',
                  positions: 'problem',
                },
                {
                  label: '巡查上报',
                  type: 'custom',
                  icon: 'riverDetails',
                  positions: 'xcsb',
                },
                {
                  label: '自动告警',
                  type: 'custom',
                  icon: 'riverDetails',
                  positions: 'zdgj',
                },
              ],
            },
            {
              label: '水文监测',
              children: [
                {
                  label: '水文站',
                  type: 'custom',
                  icon: '水文站',
                  positions: 'swz',
                },
              ],
            }
          ],
        },
      ],
      selectData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      patrolDatas: [],
      Interval: undefined,
      api: new SjApi(),
      pubapi: new PublicApi(),
      problemType: '16',
      problemTypeList: [],
    }
  },
  watch: {
    defaultCheckedKeys() { },
    $route(to) {
      this.showTimeUnit = false
      switch (to.name) {
        case 'main':
          this.subType = 1;
          this.mType = 1;
          mapService.removeLyLayer();
          mapService.removeLjhLayer();
          mainStore.setLegendType(1);
          this.$nextTick(() => {
            this.$refs['layers-manage-tree'].setCheckedKeys(['干流', '支流'])
            this.defaultCheckedKeys = ['干流', '支流']
          })
          break
        case 'profile':
          this.subType = 1;
          this.mType = 1;
          mapService.removeLyLayer();
          mapService.removeLjhLayer();
          mainStore.setLegendType(1);
          this.$nextTick(() => {
            this.$refs['layers-manage-tree'].setCheckedKeys(['河道视频', '干流', '支流', '在线巡河'])
            this.defaultCheckedKeys = ['河道视频', '干流', '支流', '在线巡河']
          })
          break
        case 'dispatch':
          this.subType = 1;
          this.mType = 1;
          mapService.removeLyLayer();
          mapService.removeLjhLayer();
          mainStore.setLegendType(1);
          this.$nextTick(() => {
            this.showTimeUnit = true
            this.$refs['layers-manage-tree'].setCheckedKeys([
              '干流',
              '支流',
              '任务交办',
              '在线巡河',
              '问题上报',
            ])
            this.defaultCheckedKeys = [
              '干流',
              '支流',
              '任务交办',
              '在线巡河',
              '问题上报'
            ]
          })
          // this.defaultCheckedKeys = ['干流', '支流', '巡查上报', '自动告警', '河道视频']
          break
        case 'work':
          this.subType = 1;
          this.mType = 1;
          mapService.removeLyLayer();
          mapService.removeLjhLayer();
          mainStore.setLegendType(1);
          this.$nextTick(() => {
            this.$refs['layers-manage-tree'].setCheckedKeys(['干流', '支流'])
            this.defaultCheckedKeys = ['干流', '支流']
          })
          break
        case 'enviroment':
          this.subType = 1;
          this.mType = 1;
          mapService.removeLyLayer();
          mapService.removeLjhLayer();
          mainStore.setLegendType(1);
          this.$nextTick(() => { })
          this.$nextTick(() => {
            this.$refs['layers-manage-tree'].setCheckedKeys(['水质自动监测站', '干流', '支流'])
            this.defaultCheckedKeys = ['水质自动监测站', '干流', '支流', '水文站']
          })
          break
        case 'pollution':
          this.$refs['layers-manage-tree'].setCheckedKeys([
            '污水处理厂（站）',
            // '污水排放口',
            '干流',
            '支流',
          ])
          this.defaultCheckedKeys = [
            '污水处理厂（站）',
            '干流',
            '支流'
          ]
          break
        case 'safty':
          this.subType = 1;
          this.mType = 1;
          mapService.removeLyLayer();
          mapService.removeLjhLayer();
          mainStore.setLegendType(1);
          this.$nextTick(() => {
            this.$refs['layers-manage-tree'].setCheckedKeys(['饮用水源地', '干流', '支流'])
            this.defaultCheckedKeys = ['饮用水源地', '干流', '支流']
          })
          break
        case 'outfall':
          this.subType = 1;
          this.mType = 1;
          mapService.removeLyLayer();
          mapService.removeLjhLayer();
          mainStore.setLegendType(1);
          this.$nextTick(() => {
            this.$refs['layers-manage-tree'].setCheckedKeys(['污水排放口', '干流', '支流'])
            this.defaultCheckedKeys = ['污水排放口', '干流', '支流']
          })
        default:
      }
      // if (this.mapLoaded) {
      this.$nextTick(() => {
        this.layersManage({ children: this.data }, { checkedKeys: this.defaultCheckedKeys })
      })
      // }
    },
  },
  mounted() {
    // 图层管理
    Bus.on('onLyChange', (ly) => {
      mapService.removeAllLayer()
      this.ly = ly
      this.zjName = ''
      this.layersManage({ children: this.data }, { checkedKeys: this.defaultCheckedKeys })
    })
    Bus.on('layersManageZJ', (zj) => {
      mapService.removeAllLayer()
      this.ly = ''
      this.zjName = zj
      this.layersManage({ children: this.data }, { checkedKeys: this.defaultCheckedKeys })
    })
    // 复位
    Bus.on('layersManageReset', () => {
      switch (this.$route.name) {
        case 'Main':
          this.$refs['layers-manage-tree'].setCheckedKeys(['干流', '支流', '在线巡河'])
          this.defaultCheckedKeys = ['干流', '支流', '在线巡河']
          break
        case 'profile':
          this.$refs['layers-manage-tree'].setCheckedKeys(['河道视频', '干流', '支流', '在线巡河'])
          this.defaultCheckedKeys = ['河道视频', '干流', '支流', '在线巡河']
          break
        case 'dispatch':
          this.$refs['layers-manage-tree'].setCheckedKeys([
            '干流',
            '支流',
            '问题上报',
            '任务交办',
            // '河道视频',
            '在线巡河',
          ])
          this.defaultCheckedKeys = [
            '干流',
            '支流',
            '问题上报',
            '任务交办',
            // '河道视频',
            '在线巡河',
          ]
          break
        case 'work':
          this.$refs['layers-manage-tree'].setCheckedKeys(['干流', '支流'])
          this.defaultCheckedKeys = ['干流', '支流']
          break
        case 'enviroment':
          this.$refs['layers-manage-tree'].setCheckedKeys(['水质自动监测站', '干流', '支流'])
          this.defaultCheckedKeys = ['水质自动监测站', '干流', '支流']
          break
        case 'pollution':
          this.$refs['layers-manage-tree'].setCheckedKeys(['污水处理厂（站）', '干流', '支流'])
          this.defaultCheckedKeys = ['污水处理厂（站）', '干流', '支流']
          break
        case 'safty':
          this.$refs['layers-manage-tree'].setCheckedKeys(['饮用水源地', '干流', '支流'])
          this.defaultCheckedKeys = ['饮用水源地', '干流', '支流']
          break
        case 'outfall':
          this.$refs['layers-manage-tree'].setCheckedKeys(['污水排放口', '干流', '支流'])
          this.defaultCheckedKeys = ['污水排放口', '干流', '支流']
        default:
      }
      this.ly = ''
      this.zjName = ''
      this.layersManage({ children: this.data }, { checkedKeys: this.defaultCheckedKeys })
    })
    this.layers = []

    // 初始化静态数据
    this.fetchProblemTypeList()
  },
  methods: {
    setSub() {
      if (this.subType == 1) {
        mainStore.setLegendType(1);
        this.mType = 1;
        mapService.removeLyLayer();
        mapService.removeLjhLayer();
        this.selectData = [];
        this.layersManage({ children: this.data }, { checkedKeys: this.defaultCheckedKeys });
      }
      if (this.subType == 2) {
        this.selectData.forEach(item => {
          this.closeLayer(item);
        })
        mapService.addLyLayer();
      }
    },
    setM(val) {
      console.log('val----->', val);
      if (val === 1) {
        mapService.removeLjhLayer();
        this.setSub();
        mainStore.setLegendType(1);
      }
      if (val === 2) {
        mapService.removeLyLayer();
        mapService.removeLjhLayer();
        mapService.addLjhLayer(2);
        mainStore.setLegendType(2);
      }
      if (val === 3) {
        mapService.removeLyLayer();
        mapService.removeLjhLayer();
        mapService.addLjhLayer(3);
        mainStore.setLegendType(3);
        // const pointData = {
        //   type: 'FeatureCollection',
        //   features: [
        //     {
        //       geometry: {
        //         type: 'Point',
        //         coordinates: [105.918014, 29.168635],
        //       },
        //       properties: {
        //         name: '',
        //         showName: false,
        //         // modalType: '引调提水',
        //         icon: `土壤.png`,
        //       },
        //       type: 'Feature',
        //       id: 0,
        //     }
        //   ],
        // }
        // const breathe = new BreatheLayer('土壤', pointData, '', 1.2, false)
        // breathe.showAnimate(1000, 'Elastic.Out')
      }
      if (val === 4) {
        mapService.removeLyLayer();
        mapService.removeLjhLayer();
        mapService.addLjhLayer(4);
        mainStore.setLegendType(4);
      }
      if (val === 5) {
        mapService.removeLyLayer();
        mapService.removeLjhLayer();
        mapService.addLjhLayer(5);
        mainStore.setLegendType(5);
      }
    },
    fetchProblemTypeList() {
      this.pubapi.screen.problemTypeDropBoxUsingPost().then((res) => {
        if (res.data) {
          this.problemTypeList = res.data.map((item) => {
            return {
              label: item.name,
              value: item.value,
            }
          })
        }
      })
    },
    onProblemTypeChange(val) {
      this.problemType = val
      mapService.removeAllLayer()
      this.layersManage({ children: this.data }, { checkedKeys: this.defaultCheckedKeys })
    },
    handleNodeClick(data, checked) {
      this.defaultCheckedKeys = checked.checkedKeys
      this.layersManage(data, checked)
    },
    layersManage(data, checked) {
      if (data.children && data.children.length >= 0) {
        for (let i = 0; i < data.children.length; i += 1) {
          this.layersManage(data.children[i], checked)
        }
      } else {
        let flag = false
        for (let i = 0; i < checked.checkedKeys.length; i += 1) {
          if (data.label === checked.checkedKeys[i]) {
            flag = true
            this.openLayer(data)
            break
          }
        }
        if (!flag) {
          this.closeLayer(data)
        }
      }
    },

    // 打开图层
    openLayer(data) {
      if (this.$router.currentRoute.value.name == 'pollution') {
        // console.log('select----->', data);
        this.selectData.push(data);
        this.selectData = Array.from(new Set(this.selectData));
        this.selectData = this.selectData.filter(item => { return item.label != '干流' && item.label != '支流' });
        // console.log('selectData----->', this.selectData);
      }
      if (data.label === '无人机航拍') {
        this.closeLayer(data)
        getWrjPathListUsingGET().then((res) => {
          console.log(res, '无人机航拍')
          const pointsData = []
          if (res) {
            res.map((point) => {
              pointsData.push({
                coordinates: [parseFloat(point.startJd), parseFloat(point.startWd)],
                properties: {
                  id: point.id,
                  category: 'wrj',
                  modalType: '无人机巡河',
                  jd: parseFloat(point.startJd),
                  wd: parseFloat(point.startWd),
                },
              })
            })
          }
          mapService.addPointsLayer('UAVPoint', pointsData, 'UAV', 1, 'center')
        })
      }
      let poi = []
      if (data.positions) {
        let _this = this
        const params = {
          positions: data.positions,
          ly: this.ly,
          zjName: this.zjName,
          keyword: this.keyword,
          timeUnit: this.timeUnit,
          period: this.timeUnit,
          problemType: this.problemType,
        }
        _this.api.screen.mapfilterUsingGet(params).then((response) => {
          const res = response.data
          // 点位弹窗
          let modalType = null
          if (data.label !== '无人机航拍' && res.positions === 'xh_online') {
            modalType = '在线巡河'
          }
          switch (res.positions) {
            case 'sgjcdm':
              modalType = '手工监测断面'
              break
            case 'szzdjcz':
              modalType = '自动监测断面'
              break
            case 'wsclc':
              modalType = '污水处理厂'
              break
            case 'zdgyqy':
              modalType = '工业企业'
              break
            case 'gmhxmyz':
              modalType = 'gmhxmyz'
              break
            case 'pwk':
              modalType = 'pwk'
              break
            case 'scyz':
              modalType = 'scyz'
              break
            case 'sk':
              modalType = '水库'
              break
            case 'swz':
              modalType = '水文站'
              break
            case 'yysyd':
              modalType = '饮用水源地'
              break
            case 'spjcd':
              modalType = '河道视频监控'
              break
            case 'xcsb':
            case 'zdgj':
            case 'rwjb':
            case 'problem':
              modalType = '问题详情'
              break
          }
          // 巡河点位
          if (res.xhList && res.xhList.length > 0) {
            _this.patrolDatas = res.xhList
            let patrolDatas = _this.patrolDatas
            const initGj = async () => {
              for (let i = 0; i < patrolDatas.length; i++) {
                mapService.removeLayer('巡河记录' + i)
                mapService.removeLayer('巡河轨迹' + i)
              }
              const xhdata = res.xhList
              for (let i = 0; i < xhdata.length; i++) {
                const zb = []
                for (let m = 0; m < xhdata[i].zb.length; m++) {
                  zb.push(
                    gcoord.transform(
                      xhdata[i].zb[m], // 经纬度坐标
                      gcoord.GCJ02, // 当前坐标系
                      gcoord.EPSG4326 // 目标坐标系
                    )
                  )
                }
                await mapService.drawTrajectory('巡河轨迹' + i, zb, null, 6, {
                  ...xhdata[i],
                  modalType: '巡河记录',
                })
                await mapService.getMap().setLayerZoomRange('巡河轨迹' + i, 12.5, 20)

                const pointData = {
                  nameShow: true,
                  type: 'FeatureCollection',
                  features: [
                    {
                      geometry: {
                        type: 'Point',
                        coordinates: gcoord.transform(
                          [parseFloat(xhdata[i].qdjd), parseFloat(xhdata[i].qdwd)], // 经纬度坐标
                          gcoord.GCJ02, // 当前坐标系
                          gcoord.EPSG4326 // 目标坐标系
                        ),
                      },
                      properties: {
                        ...xhdata[i],
                        icon: '起点.png',
                        modalType: '巡河记录',
                      },
                      type: 'Feature',
                    },
                    {
                      geometry: {
                        type: 'Point',
                        coordinates: gcoord.transform(
                          [parseFloat(xhdata[i].zdjd), parseFloat(xhdata[i].zdwd)], // 经纬度坐标
                          gcoord.GCJ02, // 当前坐标系
                          gcoord.EPSG4326 // 目标坐标系
                        ),
                      },
                      properties: {
                        ...xhdata[i],
                        icon: '终点.png',
                        modalType: '巡河记录',
                      },
                      type: 'Feature',
                    },
                  ],
                }
                for (let m = 0; m < xhdata[i].prints.length; m += 1) {
                  pointData.features.push({
                    geometry: {
                      type: 'Point',
                      coordinates: [
                        parseFloat(xhdata[i].prints[m].jd),
                        parseFloat(xhdata[i].prints[m].wd),
                      ],
                    },
                    properties: {
                      ...xhdata[i],
                      name: xhdata[i].prints[m].zdjgd,
                      icon: '重点监管.png',
                      modalType: '巡河记录',
                    },
                    type: 'Feature',
                    id: m,
                  })
                }
                const breathe = await new BreatheLayer('巡河记录' + i, pointData, ``, 0.8, false)
                breathe.showAnimate(1000, 'Elastic.Out')
                _this.layers.push(breathe)
                await mapService.getMap().setLayerZoomRange('巡河记录' + i, 12.5, 20)
                await mapService.getMap().setLayerZoomRange('巡河记录' + i + '-text', 12.5, 20)
              }
            }
            const initPoint = () => {
              const xhdata = res.xhList
              const pointData = {
                type: 'FeatureCollection',
                features: [],
              }
              for (let i = 0; i < xhdata.length; i += 1) {
                const result = gcoord.transform(
                  [parseFloat(xhdata[i].jd), parseFloat(xhdata[i].wd)], // 经纬度坐标
                  gcoord.GCJ02, // 当前坐标系
                  gcoord.EPSG4326 // 目标坐标系
                )
                pointData.features.push({
                  geometry: {
                    type: 'Point',
                    coordinates: result,
                  },
                  properties: { ...xhdata[i], modalType: '在线巡河' },
                  type: 'Feature',
                })
              }
              _this.closeLayer(data)
              const breathe = new BreatheLayer(
                data.positions,
                pointData,
                `${data.icon}.png`,
                1,
                false
              )
              breathe.showAnimate(1000, 'Elastic.Out')
              _this.layers.push(breathe)
            }
            initGj()
            initPoint()
          }
          // 视频监控点
          if (res.spjcdList && res.spjcdList.length > 0) {
            const pointData = {
              type: 'FeatureCollection',
              features: [],
            }
            for (let i = 0; i < res.spjcdList.length; i += 1) {
              let icon = '河道视频'
              let color = '#98DAFF'
              if (!res.spjcdList[i].onlined) {
                // 是否在线
                icon = `${icon}_0`
                color = '#D9D9D9'
              }
              pointData.features.push({
                geometry: {
                  type: 'Point',
                  coordinates: [
                    parseFloat(res.spjcdList[i].longitude),
                    parseFloat(res.spjcdList[i].latitude),
                  ],
                },
                properties: {
                  ...res.spjcdList[i],
                  name: res.spjcdList[i].deviceName,
                  icon,
                  color,
                  category: 'spjcd',
                  modalType,
                },
                type: 'Feature',
                id: i,
              })
            }
            const breathe = new BreatheLayer(data.positions, pointData, '', 1, false)
            breathe.showAnimate(1000, 'Elastic.Out')
            this.layers.push(breathe)
          }
          // 地图坐标点位
          if (res.dotMapList && res.dotMapList.length > 0) {
            let size
            const pointData = {
              type: 'FeatureCollection',
              features: [],
            }
            const Dicon = data.icon
            for (let i = 0; i < res.dotMapList.length; i += 1) {
              let icon = Dicon
              if (res.dotMapList[i].gkjb) {
                if (res.dotMapList[i].gkjb === '区县控') {
                  icon = '区控'
                } else {
                  icon = res.dotMapList[i].gkjb
                }
              }
              if (res.dotMapList[i].categoryStr) {
                if (res.dotMapList[i].categoryStr === '一体化水质自动监测站') {
                  icon = '一体化'
                } else if (res.dotMapList[i].categoryStr === '物联型水质自动监测站') {
                  icon = '物联'
                }
              }
              if (res.dotMapList[i].pollutionLevel) {
                switch (res.dotMapList[i].pollutionLevel) {
                  case 'Ⅰ':
                  case '1':
                    icon = `${icon}_1类`
                    break
                  case 'Ⅱ':
                  case '2':
                    icon = `${icon}_2类`
                    break
                  case 'Ⅲ':
                  case '3':
                    icon = `${icon}_3类`
                    break
                  case 'Ⅳ':
                  case '4':
                    icon = `${icon}_4类`
                    break
                  case 'Ⅴ':
                  case '5':
                    icon = `${icon}_5类`
                    break
                  case '劣Ⅴ':
                  case '6':
                    icon = `${icon}_劣5类`
                    break
                  default:
                }
              } else {
                if (
                  data.positions != 'xcsb' &&
                  data.positions != 'zdgj' &&
                  data.positions != 'rwjb' &&
                  data.positions != 'problem'
                ) {
                  if (res.dotMapList[i].online) {
                    // 是否在线
                    if (res.dotMapList[i].standard) {
                      // 是否超标
                      if (res.dotMapList[i].standard === 'cb') {
                        icon = `${icon}_1`
                      }
                      if (res.dotMapList[i].standard === 'wsj') {
                        icon = `${icon}_0`
                      }
                    }
                  } else {
                    if (res.positions != 'sk' && res.positions != 'zdgyqy' && res.positions != 'swz') icon = `${icon}_0`;
                  }
                } else {
                  size = 2
                }
              }
              // icon = `${icon}.png`;
              pointData.features.push({
                geometry: {
                  type: 'Point',
                  coordinates: [parseFloat(res.dotMapList[i].jd), parseFloat(res.dotMapList[i].wd)],
                },
                properties: {
                  ...res.dotMapList[i],
                  icon: `${icon}.png`,
                  jd: res.dotMapList[i].jd,
                  wd: res.dotMapList[i].wd,
                  modalType,
                },
                type: 'Feature',
                id: i,
              })
            }
            console.log(pointData, 'pointData.features')
            const breathe = new BreatheLayer(data.positions, pointData, ``, 1.2, false)
            breathe.showAnimate(1000, 'Elastic.Out')
            this.layers.push(breathe)
          }
        })
        // }
      }
      if (data.layers) {
        for (let i = 0; i < data.layers.length; i += 1) {
          mapService.showLayer(data.layers[i])
        }
      }
    },

    // 关闭图层
    closeLayer(data) {
      if (data.positions) {
        mapService.removeLayer(data.positions)
      }
      if (data.layers) {
        for (let i = 0; i < data.layers.length; i += 1) {
          mapService.hideLayer(data.layers[i])
        }
      }
      if (data.label === '无人机航拍') {
        mapService.removeLayer('UAVPoint')
        mapService.removeLayer('UAVtrajectory')
      }
    },

    // 搜索
    search() {
      mapService.removeAllLayer()
      this.layersManage({ children: this.data }, { checkedKeys: this.defaultCheckedKeys })
    },

    renderRiversByWaterQuality() {
      autoSiteLastWaterLevelUsingGET().then((res) => {
        mapService.renderRiversByWaterQuality(res)
      })
    },

    changeTimeUnit(data) {
      this.timeUnit = data
      mapService.removeAllLayer()
      this.layersManage({ children: this.data }, { checkedKeys: this.defaultCheckedKeys })
    },
  },
  beforeUnmount() {
    Bus.off('onLyChange', this.onLyChange)
  },
}
</script>

<style lang="scss" scoped>
.layers-manage {
  width: 22.5rem;
  position: absolute;
  right: 43rem;
  top: 12rem;
  z-index: 9;

  .filter_bar {
    position: absolute;
    top: 0px;
    left: -200px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .timeUnit {
      display: flex;

      .timeUnitItem {
        background: rgba(4, 110, 170, 0.9);
        padding: 2px 10px;
        margin-left: 10px;
        font-size: 16px;
        cursor: pointer;
      }

      .active {
        background: #0086e8;
      }
    }
  }

  .pollution {
    display: flex;
    margin-bottom: 10px;

    ::v-deep .el-radio {
      color: #fff;
      background: transparent;
      width: 100%;
      margin: 0;
      margin-right: 6px;
    }
  }

  .ljh {}

  ::v-deep .el-radio {
    color: #fff;
    background: rgba(52, 78, 92, 0.5);
    width: 100%;
    padding: 0 5px;
    margin: 2px 0;
    margin-right: 6px;
  }

  ::v-deep .el-radio.is-bordered.is-checked {
    color: #65e1c4;
    border-color: #65e1c4;
  }

  ::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #65e1c4;
  }

  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #65e1c4;
    background: #65e1c4;
  }

  ::v-deep .input-with-select {
    padding: 0;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    border: 1px solid #76ffe6;

    .el-input__inner {
      padding: 0.85rem 0.75rem;
      height: 2.8rem;
      border-radius: 0;
      border: none;
      background: rgba(17, 67, 64, 0.9);

      &::-webkit-input-placeholder {
        /* Edge */
        color: rgba(118, 255, 230, 0.5);
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: rgba(118, 255, 230, 0.5);
      }

      &::placeholder {
        color: rgba(118, 255, 230, 0.5);
      }
    }

    .el-input-group__append {
      border-radius: 0;
      background: #39938d;
      border: none;
      color: #ffffff;
      padding: 0 0.85rem;
    }
  }

  .el-tree {
    color: #90dccad9;
    background-color: unset;

    ::v-deep .el-tree-node {
      .el-tree-node__content {
        height: 2.3rem;
        margin-bottom: 0.3rem;
        background: #344e5c80;

        &:hover {
          background: #344e5c80;
        }

        .el-checkbox {
          .el-checkbox__input {
            .el-checkbox__inner {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding: 0;
              position: static;
              width: 1rem;
              height: 1rem;
              left: 0;
              top: calc(50% - 0.8rem / 2);
              background: #ffffff;
              border-radius: 0.1rem;
              flex: none;
              order: 0;
              flex-grow: 0;
              margin-right: 0.6rem;

              &::after {
                left: 0.4rem;
                border-width: 0.1rem;
                border-color: #ffffff;
                height: 0.35rem;
                top: 0.25rem;
                width: 0.15rem;
              }
            }

            &.is-indeterminate {
              .el-checkbox__inner {
                background: #90dccad9;

                &::before {
                  background-color: #ffffff;
                  height: 0.2rem;
                  left: 0.1rem;
                  right: 0;
                  top: 0.35rem;
                  width: 0.9rem;
                }
              }
            }

            &.is-checked {
              .el-checkbox__inner {
                background: #90dccad9;
              }
            }
          }
        }

        .el-tree-node__label {
          font-size: 1.4rem;
          line-height: 1.1rem;
        }
      }
    }
  }
}
</style>
